import React, { useState } from 'react';

import { useDisclosure } from '@mantine/hooks';
import dayjs from 'dayjs';
import CommunicationsTableContainer from 'pages/private/owner/AthleteDetail/components/Communications/components/CommunicationsTableContainer';
import DrawerCommunication from 'pages/private/owner/AthleteDetail/components/Communications/components/DrawerNotification';
import { SearchFilters } from 'pages/private/owner/AthleteDetail/components/Communications/types';
import { AthleteRetrieve } from 'types';

import CommunicationsFilters from './components/CommunicationsFilters';

interface IAttendanceProps {
  athlete: AthleteRetrieve;
  openTabsDrawer: () => void;
}
const Communications = ({ athlete, openTabsDrawer }: IAttendanceProps): JSX.Element => {
  const today = new Date();
  const initialSearchFiltersValue: SearchFilters = {
    date: [null, today],
    notificationType: '',
    athleteId: athlete.athleteId,
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [orderingValue, setOrderingValue] = useState('-createdAt');
  const [communicationsId, setCommunicationsId] = useState<string | null>(null);
  const [isViewDrawerOpened, { open: openViewDrawer, close: closeOpenDrawer }] = useDisclosure(false);

  const handleViewCommunication = (id: string): void => {
    setCommunicationsId(id);
    openViewDrawer();
  };

  return (
    <>
      <CommunicationsFilters
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
        timeType='past'
        defaultEndDate={dayjs(today).endOf('day').toISOString()}
        openTabsDrawer={openTabsDrawer}
      />

      <CommunicationsTableContainer
        searchFilters={searchFilters}
        timeType='past'
        defaultEndDate={dayjs(today).endOf('day').toISOString()}
        setOrderingValue={setOrderingValue}
        openViewDrawer={handleViewCommunication}
        margin={0}
        bgc='gray'
      />

      <DrawerCommunication
        opened={isViewDrawerOpened}
        closeHandler={closeOpenDrawer}
        communicationsId={communicationsId}
        setCommunicationsId={setCommunicationsId}
      />
    </>
  );
};

export default Communications;
